import colorService from '../api/color'

const state = {
    colors: [],
    homeColors: {
        quote_color: null,
        background_color: null
    }
}

const getters = {
    getColorForModel: state => model => {
        const color = state.colors.find(c => model.toLowerCase().includes(c.model.toLowerCase()))
        if (color) {
            return color.hex
        }
        return null
    }
}

const actions = {
    getAllColors({state, commit}) {
        if (state.colors.length === 0) {
            return colorService.findAll().then(response => {
                commit('setColors', response.data)
                return response.data
            }, () => false)
        }
    },
    getHomeColors({state, commit}) {
        if (state.homeColors.quote_color === null) {
            return colorService.getHomeColor().then(response => {
                commit('setHomeColors', response.data)
                return response.data
            }, () => false)
        }
    }
}

const mutations = {
    setColors(state, colors) {
        state.colors = colors
    },
    setHomeColors(state, colors) {
        state.homeColors = colors
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
